import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { InputBox, Password } from "../CustomWidgets/InputBox";
import  SelectBox, { MultiSelectBox } from "../CustomWidgets/SelectBox";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { SignupSchema, basicDetailSchema } from "../validationSchema";
import axios from "axios";
import { Image, Select } from "antd";
import FlagIcon from "../../assets/egypt.svg";
import { Input } from "antd";
import "../../styles.css";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { URLS } from "../../API/API endpoints";
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function BasicDetails({
  onDataSubmit,
  email,
  mobile,
  savedata,
  data,
  shopLocationData,
}) {
  const { t, i18n } = useTranslation();
  const [shoptype, setshoptype] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    fetchData();
    // console.log("SAVEDATA", savedata);
    // console.log("DATAAA", shopLocationData);
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(
       URLS.GET_STORE_TYPE,
        { lang: i18n.language == 'ar' ? 'ar_001' : 'en_US' }
      );

      // console.log("SHOP TYPE RESPONSE", response);
      // console.log("RESPONSE", response?.data?.result?.[0]?.response);

      setshoptype(response?.data?.result?.[0]?.response);
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      mobile:
        typeof window !== "undefined"
          ? localStorage?.getItem("UserPhone")
          : mobile,
      country_code: "+20",
      user_type: savedata?.user_type ?? "Retailer",
      page: "basic_details",
      emailid: savedata?.emailid ?? "",
      storename: savedata?.storename ?? "",
      retailername: savedata?.retailername ?? "",
      shopType: savedata?.shopType ?? null,
      password: savedata?.password ?? "",
      confirmPassword: "",
    },
    validationSchema: basicDetailSchema,
     validateOnChange: false,
  validateOnBlur: false,
    onSubmit: (values) => {
      if (values.storename === values.retailername) {
        formik.setErrors({
          retailername: t("Business Owner Name must be different from Business Name"),
        });
        return; // Prevent submission
      }

      // console.log("shopLocationData----->", shopLocationData);
      
      const payload = {
        business_type: "retailer",
        shop_type: values.shopType,
        email: values?.emailid?.toLowerCase(),
        mobile: values?.mobile,
        term_condition: shopLocationData?.term_condition,
        password: values?.password,
        owner_name: values?.retailername,
        business_name: values?.storename,
        state: shopLocationData?.state,
        city: shopLocationData?.city,
        street: shopLocationData?.street,
        // street2: `${shopLocationData?.address1}${
        //   shopLocationData?.address2 ? ", " + shopLocationData?.address2 : ""
        // }`,
        street2:shopLocationData?.street2,
        delivery_area: shopLocationData?.delivery_area,
        zone_id: shopLocationData?.zone_id,
        area: shopLocationData?.area,
        country: shopLocationData?.country,
        zip: Number(shopLocationData?.zip),
        latitude: shopLocationData?.latitude,
        longitude: shopLocationData?.longitude,
        categories_ids: selectedCategories,
      };
      onDataSubmit("basicDetailsData", payload);
    },
  });

  const GetCategorires = async(id)=>{
      console.log("GetCategorires===>", id);
      try {
      const response = await axios.post(
       URLS.CATEGORIES_BY_SHOP_TYPE,
        { 
         lang: i18n.language == 'ar' ? 'ar_001' : 'en_US' ,
          shop_type_id: id
         }
      );

      // console.log("SHOP TYPE RESPONSE", response);
      console.log("Categorired===>", response?.data?.result?.categories);
      setCategories(response?.data?.result?.categories);
    } catch (error) {
      console.error(error);
    }
  }


  return (
<div className="max-h-screen overflow-y-auto px-4 py-6 scrollbar-none pb-44">
  <h1 className="text-xl font-bold ">{t("basic_details")}</h1>
  <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-1 ">
          {/* Shop Type */}
          <div className="grid grid-cols-2 gap-x-8">
            <SelectBox
              label={t("Shop Type")}
              name="shopType"
              onChange={(event)=>{
                formik.handleChange(event)
                if(shoptype?.find((item) => item?.shop_type_id == event.target.value)?.show_sub_cat_sign_up){
                  GetCategorires(event.target.value)
                }
              }}
              options={[
                { value: 0, label: t("Select Shop Type"), disabled: true },
                ...shoptype?.map((item) => ({
                  value: item?.shop_type_id,
                  label: item?.shop_type,
                })),
              ]}
              onBlur={formik.handleBlur}
              value={
                shoptype?.find((item) => item?.shop_type_id == formik.values.shopType)
                  ?.shop_type_id || 0
              }
              error={formik.errors.shopType}
              touched={formik.touched.shopType}
            />
            {shoptype?.find((item) => item?.shop_type_id == formik.values.shopType)?.show_sub_cat_sign_up && categories?.length > 0 && 
            <div>
           
            <MultiSelectBox
            tipData={t('If you sell products by weight, select the relevant categories and the associated products will be added automatically.')}
            label={t("Categories of Products Sold by Weight")}
            name="categories"
            onChange={(event)=>{
              console.log("categories==>",event.target.value);
              setSelectedCategories(event.target.value)
            }}
             placeholder={t("Select Categories")}
             defaultValue={[]}
            options={[
              ...categories?.map((item) => ({
                value: item?.id,
                label: item?.name,
              })),
            ]}
            onBlur={formik.handleBlur}
            value={selectedCategories}
            error={formik.errors.shopType}
            touched={formik.touched.shopType}
          />
          </div>
            }
            
          </div>

          {/* Business Name and Business Owner Name */}
          <div className="grid grid-cols-2 gap-x-8">
            <div>
              <InputBox
                label={t("business_name")}
                name="storename"
                placeholder={t("enter_business_name")}
                maxLength={20}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.storename}
                error={formik.errors.storename}
                touched={formik.touched.storename}
              />
            </div>
            <div>
              <InputBox
                label={t("business_owner_name")}
                name="retailername"
                placeholder={t("enter_business_ownername")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.retailername}
                error={formik.errors.retailername}
                touched={formik.touched.retailername}
              />
                {formik.errors.retailername && 
              <div className="text-red text-sm mt-1">
                {t(formik.errors.retailername)}
              </div>
            }
            </div>
          
           
          </div>

          {/* Mobile No. and Email */}
          <div className="grid grid-cols-2 gap-x-8 mt-2">
            <div className="flex flex-col mt-2">
              <label className="py-2 text-sm text-gray-600  font-medium">
                {t("phone_number")}
              </label>
              <div className="flex items-center">
                <div className="h-10 w-16 text-md text-body outline-none focus:outline-none rounded-lg border p-3 flex items-center justify-center bg-[#EBEBEB]">
                  <Image src={FlagIcon} alt="img" />
                </div>
                <Input
                  international
                  defaultCountry="EG"
                  label={t("Mobile No.")}
                  value={"0" + formik.values.mobile}
                  placeholder={formik.values.mobile}
                  onBlur={formik.handleBlur}
                  name="mobile"
                  disabled
                  className={`h-10 ms-2 text-md text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md p-3 ${
                    formik.touched.mobile && formik.errors.mobile
                      ? "border-red" // Apply red border when touched or there's an error
                      : ""
                  }`}
                />
              </div>
              {formik.touched.mobile && formik.errors.mobile && (
                <div className="text-red-500 mt-0">{formik.errors.mobile}</div>
              )}
            </div>
            <div>
              {/* <label className="font-medium text-base">
                {t("phone_number")}
              </label> */}
              <InputBox
                label={t("email")}
                name="emailid"
                placeholder={t("enter_email")}
                maxLength={30}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.emailid}
                error={formik.errors.emailid}
                touched={formik.touched.emailid}
                autoComplete="new-email"
              />
              <div className="text-red text-sm mt-1">
                {email ? t("email_already_registered") : " "}
              </div>
            </div>
          </div>

          {/* Password and Confirm Password */}
          <div className="grid grid-cols-2 gap-x-8">
            <div>
              <Password
                label={t("Password")}
                name="password"
                placeholder={t("Enter Password")}
                maxLength={20}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                error={formik.errors.password}
                touched={formik.touched.password}
                autoComplete="new-password"
              />
            </div>
            <div>
              <Password
                label={t("confirm_password")}
                name="confirmPassword"
                placeholder={t("Re-Enter Password")}
                maxLength={20}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
                error={formik.errors.confirmPassword}
                touched={formik.touched.confirmPassword}
                autoComplete="new-password"
              />
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex float-right mt-8 mb-2">
          <button
            type="submit"
            className={`w-[180px] h-[45px] text-white rounded-lg bg-primaryBlue font-semibold`}
          >
            {t("confirm")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default BasicDetails;
